import React from "react";

import styled from "styled-components";
import { space, SpaceProps, layout, LayoutProps, display } from "styled-system";

interface StyledProps extends SpaceProps, LayoutProps {
  children?: React.ReactNode;
}


const StyledContainer = styled.div<StyledProps>`
  display: flex;
  ${display}
  ${space}
  ${layout}
`;

const TransmissionSVG: React.FunctionComponent<StyledProps> = (props) => {
  return (
    <StyledContainer {...props} data-testid="transmission-container">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 18 18"
        data-testid="transmission-svg"
      >
        <path
          fill="#070B16"
          fillRule="evenodd"
          d="M16 0c-1.243 0-2.25 1.007-2.25 2.25 0 .832.453 1.557 1.125 1.946v3.679h-4.5V4.196c.212-.122.402-.279.563-.461.348-.397.562-.915.562-1.485C11.5 1.007 10.493 0 9.25 0S7 1.007 7 2.25c0 .832.453 1.557 1.125 1.946v3.679h-4.5V4.196C4.297 3.807 4.75 3.082 4.75 2.25 4.75 1.007 3.743 0 2.5 0S.25 1.007.25 2.25c0 .832.453 1.557 1.125 1.946v9.607C.703 14.193.25 14.917.25 15.75.25 16.992 1.257 18 2.5 18s2.25-1.008 2.25-2.25c0-.832-.453-1.558-1.125-1.947v-3.678h4.5v3.679C7.453 14.193 7 14.918 7 15.75 7 16.993 8.007 18 9.25 18s2.25-1.007 2.25-2.25c0-.57-.214-1.088-.563-1.485-.16-.182-.35-.339-.562-.461v-3.679H16c.621 0 1.125-.504 1.125-1.125V4.196c.672-.389 1.125-1.114 1.125-1.946C18.25 1.007 17.243 0 16 0"
        />
      </svg>
    </StyledContainer>
  );
};

export default TransmissionSVG;
